module.exports = __webpack_public_path__ + "static/fonts/ionicons.05acfdb.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/ionicons.woff?v=2.0.0
// module id = o9yR
// module chunks = 34